import { createClient, ContentfulClientApi } from 'contentful'

// TODO update this on env and get the sops done and access these data using proccess.env
const NEXT_PUBLIC_CONTENTFUL_SPACE_ID = 'uwf0n1j71a7j'
const NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN = 'Rgy__sehcpUIJi8j3l0Rhux9MeJQ0fagpGbYeDqalkk'
const NEXT_PUBLIC_CONTENTFUL_PREVIEW_ENVIRONMENT = 'True'

const createContentfulClient = () => {
  return createClient({
    space: NEXT_PUBLIC_CONTENTFUL_SPACE_ID,
    accessToken: NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN,
    host: NEXT_PUBLIC_CONTENTFUL_PREVIEW_ENVIRONMENT ? 'preview.contentful.com' : 'cdn.contentful.com',
  })
}

let contentfulClient: ContentfulClientApi | null = null

export const getContentfulClient = () => {
  if (contentfulClient === null) {
    contentfulClient = createContentfulClient()
  }
  return contentfulClient
}

export const getConfig = async (fielsIdentifier: string) => {
  const entry = await getContentfulClient().getEntries({
    content_type: 'cxKmsConfig',
    'fields.identifier': fielsIdentifier,
  })
  return entry?.items[0]
}
